<template>
  <div>
    <h3>Pending Students</h3>

    <b-form inline @submit.prevent="" class="mb-2">
      <label for="terms">Term</label>
      <b-form-select id="terms" @input="changeTerm" v-model="term" :options="terms" value-field="termId" text-field="description">
        <template slot="first">
          <option :value="null">None</option>
        </template>
      </b-form-select>

      <label for="courses">Course</label>
      <b-form-select id="courses" v-model="course" :options="courses" value-field="displayName" text-field="displayName">
        <template slot="first">
          <option :value="null">All</option>
        </template>
      </b-form-select>

      <b-input-group class="filter-group ml-2" >
        <b-input-group-prepend is-text>
            <font-awesome-icon icon="search" />
        </b-input-group-prepend>
        <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
        <b-input-group-append>
            <b-button @click="filter = null">Clear</b-button>
        </b-input-group-append>
      </b-input-group>  
    </b-form>

    <b-table striped
          hover
          :items="students"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filterItems"
          @filtered="onFiltered"
          responsive
          :sort-compare="customSort">
      <template slot="course" slot-scope="data">
        <div v-for="course in data.item.studentCourses" :key="course.classSid">
          <p>
            {{ course.subjectCode }} {{ course.catalogNumber }} 
          </p>
          <p>{{ course.unitsTaken }} credits</p>
        </div>
      </template>
      <template slot="studentOpportunities" slot-scope="data">
        <div v-if="data.item.studentOpportunities.length">
          <b-button v-b-toggle="'collapse' + data.item.asuriteId"><span class="when-opened">Hide</span> <span class="when-closed">Show</span></b-button>
          <b-collapse :id="'collapse' + data.item.asuriteId" class="mt-2">
            <b-list-group>
              <b-list-group-item v-for="studentOpportunity in data.item.studentOpportunities" :key="studentOpportunity.studentOpportunityId">
                <router-link :to="{ name: 'studentOpportunityDetails', params: { studentOpportunityId: studentOpportunity.studentOpportunityId } }">
                  <strong v-if="studentOpportunity.opportunity.name">{{studentOpportunity.opportunity.name}} @ </strong>
                  <strong>{{ studentOpportunity.opportunity.site.name }}</strong>  
                </router-link> 
                
                <div>
                  <b-badge variant="primary">{{ studentOpportunity.opportunity.opportunityType.name }}</b-badge>
                  <b-badge class="ml-1" variant="primary">{{ studentOpportunity.opportunity.opportunityCategory.name }}</b-badge>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </div>
        <span v-else>None</span>
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import terms from "../../api/terms";
import opportunities from "../../api/opportunity";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      fields: [
        { key: "lastName", label: "Last Name", sortable: true },
        { key: "firstName", label: "First Name", sortable: true },
        { key: "course", sortable: true },
        {
          key: "studentOpportunitiesCount",
          label: "# Saved",
          sortable: true
        },
        {
          key: "studentOpportunitiesWithSubmissions",
          label: "# w/ Submissions",
          sortable: true
        },
        {
          key: "studentOpportunitiesApproved",
          label: "# Approved",
          sortable: true
        },
        {
          key: "studentOpportunities",
          label: "Opportunities",
          sortable: false
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      term: null,
      terms: [],
      opportunityTypeId: null,
      opportunityCategoryId: null,
      opportunityCategories: [],
      statuses: [],
      course: null,
      courses: []
    };
  },

  computed: {
    ...mapState({
      students: state => state.studentOpportunities.students
    })
  },

  methods: {
    //...mapActions("terms", ["getTermsActive"]),
    ...mapActions("studentOpportunities", ["getPendingStudents"]),
    changeTerm() {
      this.getPendingStudents(this.term);
    },

    filterItems(item) {
      // var matchedTerm = this.matchTerm(item, this.term);
      var matchedCourse = this.matchCourse(item, this.course);

      var matchedFilter = this.matchFilter(item, this.filter);

      if (matchedCourse && matchedFilter) {
        return true;
      }
      return false;
    },
    matchCourse(item, course) {
      if (
        course === null ||
        _.filter(item.studentCourses, studentCourse => {
          return (
            course ===
            studentCourse.subjectCode + " " + studentCourse.catalogNumber
          );
        }).length
      ) {
        return true;
      }
      return false;
    },
    matchFilter(item, filter) {
      if (filter != "" && filter != null) {
        var found = this.search([item], this.filter);
        return found.length > 0;
      }
      return true;
    },
    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },
    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val, key) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    customSort(a, b, key) {
      if (key === "student.lastName") {
        return a.student.lastName.localeCompare(b.student.lastName, undefined, {
          numeric: true
        });
      } else if (key === "student.firstName") {
        return a.student.firstName.localeCompare(
          b.student.firstName,
          undefined,
          { numeric: true }
        );
      } else if (key === "opportunity.term.description") {
        return a.opportunity.term.termCode < b.opportunity.term.termCode
          ? -1
          : a.opportunity.term.termCode > b.opportunity.term.termCode
            ? 1
            : 0;
      }
      return null;
    }
  },

  watch: {
    terms: function() {
      if (this.term === null) {
        //this.term = this.terms[0].termId;
        var foundTerm = _.find(this.terms, t => {
          var start = new Date(t.termStart);
          var end = new Date(t.termEnd);
          return start.getTime() <= Date.now() && end.getTime() >= Date.now();
        });
        if (foundTerm) {
          this.term = foundTerm.termId;
        }
      }
    }
  },
  created() {
    if (this.term) {
      this.getApplicationStatus(this.term);
    }
    terms.getTerms().then(response => {
      this.terms = response.data;
    });
    opportunities.getInternshipCourses().then(response => {
      this.courses = response.data;
    });
  }
};
</script>

<style scoped>
.green {
  color: green;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.main-container {
  max-width: 100%;
  margin-top: 10px;
}
.widget-body {
  max-width: 100%;
}
/* .filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
} */

.new-content-button {
  margin-left: 10px;
}

label {
  font-weight: bold;
  margin: 0 0.3em 0 1.5em;
}

.clickable {
  cursor: pointer;
}

.sort-label {
  margin-right: 0.5em;
}

.loading-div {
  text-align: center;
  font-size: 2em;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
